import { ThemeOptions, createTheme } from "@mui/material/styles";
import { headlineFont, bodyFont } from "./fonts";
import { primaryColor, secondaryColor } from "./colors";
// Define common typography and components configurations
const commonTypography = {
  fontFamily: bodyFont, // Default font for the body text
  h1: {
    fontFamily: headlineFont,
  },
  h2: {
    fontFamily: headlineFont,
  },
  h3: {
    fontFamily: headlineFont,
  },
  h4: {
    fontFamily: headlineFont,
  },
  h5: {
    fontFamily: headlineFont,
  },
  h6: {
    fontFamily: headlineFont,
  },
};

const commonComponents = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "20px",
        // Add empty objects for variants you want to override
        contained: {},
        outlined: {},
        text: {},
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        padding: "16px",
      },
    },
  },
};

// Create a base theme configuration
const baseTheme: ThemeOptions = {
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
  },
  typography: commonTypography,
  components: commonComponents,
};

// Extend the base theme for light mode
export const theme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    mode: "light",
  },
});

// Extend the base theme for dark mode
export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    mode: "dark",
    background: {
      default: "#000",
    },
  },
});
